import { render, staticRenderFns } from "./CollectionDescription.vue?vue&type=template&id=423734ce&scoped=true&"
import script from "./CollectionDescription.vue?vue&type=script&lang=js&"
export * from "./CollectionDescription.vue?vue&type=script&lang=js&"
import style0 from "./CollectionDescription.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CollectionDescription.vue?vue&type=style&index=1&id=423734ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423734ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\collection-gifting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('423734ce')) {
      api.createRecord('423734ce', component.options)
    } else {
      api.reload('423734ce', component.options)
    }
    module.hot.accept("./CollectionDescription.vue?vue&type=template&id=423734ce&scoped=true&", function () {
      api.rerender('423734ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "CollectionGifting/components/CollectionDescription.vue"
export default component.exports